import React from 'react';
import { useStore } from '../context/store';

export default function Cards() {
	const { state } = useStore();

	function FeaturedImage(props) {
		if (!props.item.featured_image) {
			return '';
		}

		return (
			<figure
				className="series-card__figure"
				dangerouslySetInnerHTML={{
					__html: props.item.featured_image,
				}}
			/>
		);
	}

	if (null !== state.series && state.series.length) {
		const cardsToShow = state.currentPage * state.cardsPerPage;
		const series = state.series.slice(0, cardsToShow);

		return (
			<div className="series-app__cards">
				{series.map((item) => {
					return (
						<a
							className="series-card"
							key={item.term_id}
							href={item.link}
						>
							<FeaturedImage item={item} />

							<div className="series-card__text">
								<div className="series-card__subtitle">
									Series
								</div>

								<h3
									className="series-card__title"
									dangerouslySetInnerHTML={{
										__html: item.name,
									}}
								></h3>

								<div className="series-card__count">
									{item.count} tools
								</div>
							</div>
						</a>
					);
				})}
			</div>
		);
	}

	return '';
}
